import request from "./request";
//数据总览
export const getPlatAdvertiser = (data) => request("/bi/getPlatAdvertiser", data, "POST");
export const getCampaign = (data) => request("/bi/getCampaign", data, "POST");
export const allReport = (data) => request("/bi/allReport", data, "GET");

//渠道配置
export const queryConvertPara = (data) => request("/convert/queryConvertPara", data, "GET");
export const saveConvertPara = (data) => request("/convert/saveConvertPara", data, "POST");

export const queryCbPara = (data) => request("/convert/queryCbPara", data, "GET");
export const addCbPara = (data) => request("/convert/addCbPara", data, "POST_JSON");
// export const modifyCbPara = (data) => request("/convert/modifyCbPara", data, "POST");
// export const deleteCbPara = (data) => request("/convert/deleteCbPara", data, "POST");
// export const updateActiveStatus = (data) => request("/convert/updateActiveStatus", data, "POST");

//追踪管理
export const queryDataTrackPara = (data) =>
  request("/convert/queryDataTrackPara", data, "GET");
export const addDataTrackPara = (data) => request("/convert/addDataTrackPara", data, "POST");
export const modifyDataTrackPara = (data) =>
  request("/convert/modifyDataTrackPara", data, "POST");
export const deleteDataTrackPara = (data) =>
  request("/convert/deleteDataTrackPara", data, "POST");

// 任务中心
// 获取任务列表
export const getTaskList = (data) => request("/task/getTaskList", data, "POST");
// 获取失败任务详情
export const getFailTaskDetail = (data) => request("/task/getFailTaskDetail", data, "GET");
// 归因产品管理
// 查询归因服务产品列表
export const queryConvertProduct = (data) =>
  request("/convert/queryConvertProduct", data, "GET");
// 新增归因服务产品
export const addConvertProduct = (data) =>
  request("/convert/addConvertProduct", data, "POST");
// 修改归因服务产品
export const modifyConvertProduct = (data) =>
  request("/convert/modifyConvertProduct", data, "POST");
// 删除归因服务产品
export const delConvertProduct = (data) =>
  request("/convert/delConvertProduct", data, "GET");

// 留存数据
export const getRetentionData = (data) => request("/convert/retention", data, "GET");
// 归因模板
// 查询归因模板
export const getAllConvertTemplate = () =>
  request("/convert/selectAllConvertTemplate", null, "GET");
// 新增归因模板
export const addConvertTemplate = (data) =>
  request("/convert/addConvertTemplate", data, "POST");
// 修改归因模板
export const modifyConvertTemplate = (data) =>
  request("/convert/modifyConvertTemplate", data, "POST");
// 删除归因模板
export const delConvertTemplate = (data) =>
  request("/convert/delConvertTemplate", data, "GET");

//数据总览
// 折线图数据
export const getLineGraph = (data) => request("/convert/barGraph", data, "GET");
// 归因数据总览
export const getConvertData = (data) => request("/convert/convertData", data, "GET");
// 环比数据
export const getCalculateChainData = (data) =>
  request("/convert/calculateChainData", data, "GET");
